import { bindSbpTokenApi } from '../../api/bind-sbp-token';
import type { ApiHost, BindSbpTokenOptions } from '../../types';
import { paymentForm } from '../payment-form';

export const bindSbpToken = async (apiHost: ApiHost, options: BindSbpTokenOptions) => {
    const { purchaseToken } = options;

    const url = await bindSbpTokenApi(apiHost, { purchaseToken });

    return paymentForm(apiHost, { url });
};
